import {DropzoneComponent} from 'react-dropzone-component';
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import React, {Component} from 'react';
import {Button, Header, Icon,Grid, Form, Segment, Dropdown} from 'semantic-ui-react';
import {uploadPVChecklistDetails} from "../../data/property_visit_api";
import * as unavailable from "../../assets/photo_unavailable.jpg";
import Loader from "../universal/loader";
import { isSessionExpiringSoon } from '../../utils/validate_session_expiry';

const uuidv1 = require('uuid/v1');

class PropertyVisitReportChecklist extends Component {

    constructor(props) {
        super(props);
      this.state = {
        saved: false,
        uploading: false,
        petsEvidence: undefined,
        smokingEvidence: undefined,
        blindsSafety:undefined,
        petsNotes: undefined,
        smokingNotes: undefined,
        cleanlinessNotes: undefined,
        decorNotes:undefined,
        blindsNotes:undefined,
        notSaved: false,
        errorSaving:false
        };
    }
  componentDidMount() {
    this.setState({
      petsEvidence: this.props.reportData.evidence_of_pets,
      smokingEvidence: this.props.reportData.evidence_of_smoking,
      blindsSafety:this.props.reportData.blinds_safety,
      blindsNotes:this.props.reportData.blinds_notes,
      petsNotes: this.props.reportData.evidence_of_pets_notes,
      smokingNotes: this.props.reportData.evidence_of_smoking_notes,
      cleanlinessNotes: this.props.reportData.general_cleanliness,
      decorNotes: this.props.reportData.decor_notes,
    })
 }
  uploadChecklist = () => {
    if(isSessionExpiringSoon()){
      this.props.showPasswordWindow(true);
      return;
  }
      this.setState({uploading:true});
      let formData = {}
    let formDataDict = {
      petsEvidence: this.state.petsEvidence,
        smokingEvidence: this.state.smokingEvidence,
        petsNotes: this.state.petsNotes,
        smokingNotes: this.state.smokingNotes,
        cleanlinessNotes: this.state.cleanlinessNotes,
        blindsSafety:this.state.blindsSafety,
        blindsNotes:this.state.blindsNotes,
        decorNotes:this.state.decorNotes
      }
      formData.report_id = this.props.reportId
      formData.checklist_details = JSON.stringify(formDataDict)
      uploadPVChecklistDetails(formData).then((response) => {
          if (response.success) {
              this.setState({ saved: true, uploading: false, notSaved:false });
              setTimeout(() => {
                  this.setState({saved: false,});
              }, 4000);
          }
          else {
              this.setState({ uploading: false,errorSaving:true });
        }
      }
      );
  };


    render() {
      const generalCleanlinessOptions = [
        { key: '1', value: 'Clean, good order', text: 'Clean, good order' },
        { key: '2', value: 'Clean, well maintained throughout', text: 'Clean, well maintained throughout' },
        { key: '3', value: 'Cluttered but clean', text: 'Cluttered but clean' },
        { key: '4', value: 'Cluttered not clean', text: 'Cluttered not clean' },
        { key: '5', value: 'Untidy throughout', text: 'Untidy throughout' },
        { key: '6', value: 'Not clean, untidy', text: 'Not clean, untidy' },
        { key: '7', value: 'Various issues reported but generally clean', text: 'Various issues reported but generally clean' },
    ];

const decorOptions = [
    { key: '1', value: 'Very well maintained throughout', text: 'Very well maintained throughout' },
    { key: '2', value: 'All in good order', text: 'All in good order' },
    { key: '3', value: 'Generally good order apart from where noted', text: 'Generally good order apart from where noted' },
    { key: '4', value: 'Scuffed and marked in places', text: 'Scuffed and marked in places' },
    { key: '5', value: 'In poor order', text: 'In poor order' },
];
    
      return (
          <Segment>
          {this.state.isSaving && <Loader save={true} />}
            <Header textAlign="left"> Checklist{this.state.saved && <span className="info-success">Saved!</span>}
            {this.state.notSaved && <span className="info-negative">Not Saved</span>}
              <Button primary compact content="Save" disabled={this.state.uploading || this.state.petsEvidence === undefined || this.state.smokingEvidence === undefined} loading={this.state.uploading}
                className="pull-right icon-button" onClick={(e) => {
                  this.uploadChecklist();
                }}/> </Header>

            <div>
              <Form>
                <Grid stackable columns={4} divided="vertically">
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <div style={{ textAlign: "center" }}>
                        <Form.Field>
                          <label>Evidence of Pets</label>
                          <Button.Group>
                            <Button
                              positive={this.state.petsEvidence == true}
                              onClick={() =>
                                this.setState({ petsEvidence: true,notSaved:true })
                              }
                            >
                              Yes
                            </Button>
                            <Button.Or />
                            <Button
                              negative={this.state.petsEvidence == false}
                              onClick={() =>
                                this.setState({ petsEvidence: false, notSaved:true })
                              }
                            >
                              No
                            </Button>
                          </Button.Group>
                        </Form.Field>
                      </div>
                    </Grid.Column>
                    <Grid.Column width={13}>
                      <Form.Field
                        onChange={(e) => {
                                            this.setState({petsNotes:e.target.value, notSaved:true})
                        }}
                      >
                        <label>Notes</label>
                        <input value={this.state.petsNotes|| "" } />
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <div style={{ textAlign: "center" }}>
                        <Form.Field>
                          <label>Evidence of Smoking</label>
                          <Button.Group>
                            <Button
                              positive={this.state.smokingEvidence == true}
                              onClick={() =>
                                this.setState({ smokingEvidence: true, notSaved:true })
                              }
                            >
                              Yes
                            </Button>
                            <Button.Or />
                            <Button negative={this.state.smokingEvidence == false}
                              onClick={() =>
                                this.setState({ smokingEvidence: false, notSaved:true })
                              }>No</Button>
                          </Button.Group>
                        </Form.Field>
                      </div>
                    </Grid.Column>
                    <Grid.Column width={13}>
                      <Form.Field
                        onChange={(e) => {
                            this.setState({smokingNotes:e.target.value, notSaved:true})
                        }}
                      >
                        <label>Notes</label>
                        <input value={ this.state.smokingNotes|| ""} />
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <div style={{ textAlign: "center" }}>
                        <Form.Field>
                          <label>All Blinds have Safety Cleats? </label>
                          <Button.Group>
                            <Button
                              positive={this.state.blindsSafety == true}
                              onClick={() =>
                                this.setState({ blindsSafety: true, notSaved:true })
                              }
                            >
                              Yes
                            </Button>
                            <Button.Or />
                            <Button negative={this.state.blindsSafety == false}
                              onClick={() =>
                                this.setState({ blindsSafety: false, notSaved:true })
                              }>No</Button>
                          </Button.Group>
                        </Form.Field>
                      </div>
                    </Grid.Column>
                    <Grid.Column width={13}>
                      <Form.Field
                        onChange={(e) => {
                            this.setState({blindsNotes:e.target.value, notSaved:true})
                        }}
                      >
                        <label>Notes</label>
                        <input value={ this.state.blindsNotes|| ""} />
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    
                    <Grid.Column width={16}>
                      <Form.Field>
                        <label>General Cleanliness Notes</label>
                      <Dropdown selection
                      value={this.state.cleanlinessNotes}
                                    onChange={(e, option) => {this.setState({cleanlinessNotes:option.value,notSaved:true})}}
                                    options={generalCleanlinessOptions}
                                    >

                      </Dropdown>
                        </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>  
                    <Grid.Column width={16}>
                      <Form.Field>
                        <label>General Decor Condition</label>
                      <Dropdown selection
                      value={this.state.decorNotes}
                                    onChange={(e, option) => {this.setState({decorNotes:option.value,notSaved:true})}}
                                    options={decorOptions}
                                    >
                      </Dropdown>
                        </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Form>
            </div>
            </Segment>
        );
    }
}

export default PropertyVisitReportChecklist;


// WEBPACK FOOTER //
// ./src/views/property_visits/property_visit_report_checklist.js